import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const FAMILY_TONE = {
    study: "border-sky-300/40 bg-sky-300/10 text-sky-200",
    regulatory: "border-rose-300/40 bg-rose-300/10 text-rose-200",
    manual: "border-amber-300/40 bg-amber-300/10 text-amber-200",
    training: "border-emerald-300/40 bg-emerald-300/10 text-emerald-200",
    other: "border-white/15 bg-white/5 text-white/65",
};

export const VALIDITY_META = {
    valid: { label: "valid", tone: "border-emerald-300/40 bg-emerald-300/10 text-emerald-300" },
    expiring_soon: { label: "expiring soon", tone: "border-amber-300/50 bg-amber-300/10 text-amber-200" },
    expired: { label: "expired", tone: "border-red-400/50 bg-red-400/10 text-red-300" },
    not_yet_valid: { label: "not yet valid", tone: "border-sky-300/40 bg-sky-300/10 text-sky-200" },
};

export const DOC_STATUSES = ["draft", "approved", "superseded", "withdrawn"];

let cache = null;

export function useContextVocab() {
    const [vocab, setVocab] = useState(cache || []);
    const reload = async () => {
        const { data } = await api.get("/admin/datalake/contexts");
        cache = data.items || [];
        setVocab(cache);
        return cache;
    };
    useEffect(() => { if (!cache) reload().catch(() => {}); }, []);
    const byId = Object.fromEntries(vocab.map((c) => [c.id, c]));
    const irbRelevant = (contexts) => (contexts || []).some((id) => byId[id]?.irb_relevant);
    return { vocab, byId, active: vocab.filter((c) => c.active), reload, irbRelevant };
}
